import { render, staticRenderFns } from "./BiomarkerMechanismLinkCausalNetwork.vue?vue&type=template&id=38f45c23&scoped=true"
import script from "./BiomarkerMechanismLinkCausalNetwork.vue?vue&type=script&lang=js"
export * from "./BiomarkerMechanismLinkCausalNetwork.vue?vue&type=script&lang=js"
import style0 from "./BiomarkerMechanismLinkCausalNetwork.vue?vue&type=style&index=0&id=38f45c23&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f45c23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f45c23')) {
      api.createRecord('38f45c23', component.options)
    } else {
      api.reload('38f45c23', component.options)
    }
    module.hot.accept("./BiomarkerMechanismLinkCausalNetwork.vue?vue&type=template&id=38f45c23&scoped=true", function () {
      api.rerender('38f45c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/biomarkerNetwork/BiomarkerMechanismLinkCausalNetwork.vue"
export default component.exports